//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const pleacementExamInt = []

export const placement_exam_list = (state = pleacementExamInt, action) => {
    switch (action.type) {
        case ActionTypes.exams.set_placement_exam_list:
            return action.payload;
        case ActionTypes.exams.update_placement_exam_list:
            return state.some(exam => exam.id === action.payload.id)
            ? state.map(exam => exam.id === action.payload.id ? { ...exam, ...action.payload } : exam)
            : [...state, action.payload];
        case ActionTypes.exams.clear_placement_exam_list:
            return [];
        default:
            return state;
    }
};
const pleacementExamSession = {};

export const placement_exam_session = (state = pleacementExamSession, action) => {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.exams.set_placement_session:
            return {
                [payload.key]: payload.value,
            };
        case ActionTypes.exams.set_placement_resume_session:
            return payload;
        case ActionTypes.exams.update_placement_session:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case ActionTypes.exams.clear_placement_session:
            return pleacementExamSession;
        default:
            return state;
    }
};
const placentExamSubmissionsByExamcode ={}
export const placement_exam_submission_by_examcode = (state = placentExamSubmissionsByExamcode, action) => {

    switch (action.type) {
        case ActionTypes.exams.set_placement_submission_by_exam:
            return {...state,[action.payload.assignment_code]:action.payload.submissions};
        case ActionTypes.exams.update_placement_exam_submission:
            return {
                ...state,
                [action.payload.assignment_code]: state[action.payload.assignment_code]
                    ? state[action.payload.assignment_code].some(item => item.id === action.payload.id)
                        ? state[action.payload.assignment_code].map(item =>
                            item.id === action.payload.id ? { ...item, ...action.payload } : item
                        )
                        : [...state[action.payload.assignment_code], action.payload]
                    : [action.payload],
            };
        case ActionTypes.exams.clear_placement_submission_by_exam:
            return placentExamSubmissionsByExamcode;
        default:
            return state;
    }

}
const placementExamDistrictAssignment ={}
export const placement_exam_distict_assignment = (state = placementExamDistrictAssignment, action) => {

    switch (action.type) {
        case ActionTypes.exams.set_placement_exam_distict_assignment:
            return {...state,[action.payload.exam_id]:action.payload.assign};
        case ActionTypes.exams.update_placement_exam_distict_assignment:
            return {
                ...state,
                [action.payload.exam_id]: state[action.payload.exam_id]
                    ? state[action.payload.exam_id].some(item => item.id === action.payload.id)
                        ? state[action.payload.exam_id].map(item =>
                            item.id === action.payload.id ? { ...item, ...action.payload } : item
                        )
                        : [...state[action.payload.exam_id], action.payload]
                    : [action.payload],
            };
        case ActionTypes.exams.clear_placement_exam_distict_assignment:
            return placementExamDistrictAssignment;
        default:
            return state;
    }

}

const init_placement_exam_org_config ={}
export const placement_exam_org_config = (state = init_placement_exam_org_config, action) => {
    switch (action.type) {
        case ActionTypes.exams.set_placement_exam_org_config:
            return action.payload;
        default:
            return state;
    }

}



